import React, { Component } from "react";
import ContentWrapper from "../../containers/ContentWrapper";
import ShotTable from "./ShotTable";
import AdminWrapper from "../../containers/AdminWrapper";

export default class VideoShots extends Component {

  render() {
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Video Shots" hasPadding>
            <ShotTable
              type="video"
              history={this.props.history}
              location={this.props.location}
              match={this.props.match}
            />
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}
